import React from "react";

const MinistryIcon = ({ width, height, color }) => {
	return (
		<svg
			width={width || "41"}
			height={height || "31"}
			viewBox="0 0 41 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.97144 25.7241V27.8941H38.0388V25.7241H35.687H29.9937H23.3515H17.6581H11.0161H5.32303H2.97144Z"
				fill="white"
			/>
			<path
				d="M2.47638 28.6646H1.07373V30.9999H39.9363V28.6646H38.534H2.47638Z"
				fill="white"
			/>
			<path d="M10.521 15.4347H5.81812V24.9536H10.521V15.4347Z" fill="white" />
			<path
				d="M39.4824 10.2541H41L36.4369 8.63417C36.4347 8.63343 36.4324 8.63286 36.4303 8.63212L20.5055 2.97827C18.8815 3.55832 17.3236 4.11287 15.812 4.64958C13.4392 5.49227 11.182 6.2908 8.97073 7.07313C5.96055 8.138 3.087 9.1546 0 10.2541H1.52744H39.4824ZM12.7265 7.75761C14.0097 7.34917 15.1696 6.93186 16.3973 6.48996C17.6303 6.04625 18.9052 5.58749 20.3176 5.13819C20.4424 5.09847 20.5824 5.1002 20.7056 5.14255L28.2966 7.76196C28.5104 7.83572 28.6289 8.01589 28.5804 8.194C28.5319 8.37211 28.33 8.49948 28.096 8.49948H12.9139C12.6773 8.49948 12.4737 8.36923 12.4281 8.18857C12.3824 8.00791 12.5074 7.82725 12.7265 7.75761Z"
				fill="white"
			/>
			<path
				d="M20.4975 5.9137C19.1822 6.33677 17.9787 6.76987 16.8129 7.18932C16.3175 7.3676 15.8151 7.54842 15.3025 7.72891H25.758L20.4975 5.9137Z"
				fill="white"
			/>
			<path
				d="M20.2984 2.20448C20.364 2.18105 20.4345 2.16937 20.505 2.16937C20.5751 2.16937 20.6452 2.18097 20.7105 2.20415L36.1407 7.6821V0H4.86914V7.67815C6.11732 7.23601 7.3544 6.79838 8.59718 6.35878C12.2651 5.06121 16.0577 3.71956 20.2984 2.20448Z"
				fill="white"
			/>
			<path
				d="M38.9874 11.0247H2.02246V14.664H5.3231H11.0161H17.6582H23.3515H29.9938H35.687H38.9874V11.0247Z"
				fill="white"
			/>
			<path
				d="M22.8565 15.4347H18.1533V24.9536H22.8565V15.4347Z"
				fill="white"
			/>
			<path d="M35.192 15.4347H30.4888V24.9536H35.192V15.4347Z" fill="white" />
		</svg>
	);
};

export default MinistryIcon;
